import ActionType from '../actions/ActionType'

export default (
  state = {
    credentials: null,
    credentialsErr: null,
    session: null,
    sessionErr: null,
    authState: null,
    user: null,
  },
  action,
) => {
  switch (action.type) {
    case ActionType.Auth.SIGNOUT_SUCCESS:
      return {
        ...state,
        credentials: null,
      }
    case ActionType.Auth.SIGNOUT_FAILURE:
      return {
        ...state,
        credentialsErr: action.payload,
      }
    case ActionType.Auth.CURRENT_CREDENTIALS_SUCCESS:
      return {
        ...state,
        credentials: action.payload,
      }
    case ActionType.Auth.CURRENT_CREDENTIALS_FAILURE:
      return {
        ...state,
        credentialsErr: action.payload,
      }
    case ActionType.Auth.CURRENT_SESSION_SUCCESS:
      window.ReactNativeWebView &&
        window.ReactNativeWebView.postMessage(
          `action.payload: ${action.payload}`,
        )
      return {
        ...state,
        session: action.payload,
      }
    case ActionType.Auth.CURRENT_SESSION_FAILURE:
      return {
        ...state,
        sessionErr: action.payload,
      }
    case ActionType.Auth.REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        session: action.payload,
      }
    // case ActionType.Auth.SET_AUTH_STATE:
    //   return {
    //     ...state,
    //     authState: action.payload,
    //   }
    // case ActionType.Auth.SET_USER:
    //   return {
    //     ...state,
    //     user: action.payload,
    //   }
    default:
      return state
  }
}
